import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { AppComponent } from '@app/app.component';
import { AuthInterceptor } from '@app/common/auth-interceptor';
import { RefreshPromptDialogModule } from '@app/components/refresh-prompt-dialog/refresh-prompt-dialog.component';
import { WindowModule } from '@app/modules/window/window.module';
import { AppInitService } from '@app/services/app-init.service';
import { MainModule } from '@app/views/main/main.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    WindowModule,
    MainModule,
    RefreshPromptDialogModule,
    RouterModule
  ],
  exports: [
    AppComponent,
  ]
})
export class WorkplaceAppModule {
  constructor(@Optional() @SkipSelf() parentModule: WorkplaceAppModule) {
    if (parentModule) {
      throw new Error(
        'WorkplaceAppModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders<WorkplaceAppModule> {
    return {
      ngModule: WorkplaceAppModule,
      providers: [
        [{
          provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
        }],
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [AppInitService],
          useFactory: initAndAuthenticate
        }
      ]
    };
  }
}

export function initAndAuthenticate(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.init();
  };
}
